export const sidebar = { postfix: "SideBar", collapsedParam: "collapsed" };

export const gridStepHeight = 60;
export const gridMargin = 16;

export const CAPITAL_OTHER_VALUE = "Other";
export const LOWERCASE_OTHER_VALUE = "other";

export const otherValues = [LOWERCASE_OTHER_VALUE, CAPITAL_OTHER_VALUE];

export const loaders = {
  templateManagement: "templateManagement",
};

export const LOCALSTORAGE_TENANT = "tenant";

export const FLIGHT_CADENCE_TO_TABLE_GRANULARITY = {
  Week: "week",
  Month: "month",
  Quarter: "quarter",
} as const;

export type FlightCadence = keyof typeof FLIGHT_CADENCE_TO_TABLE_GRANULARITY;
export type BudgetAllocationGranularity =
  (typeof FLIGHT_CADENCE_TO_TABLE_GRANULARITY)[keyof typeof FLIGHT_CADENCE_TO_TABLE_GRANULARITY];

export const SCENARIO_GRANULARITY: FlightCadence[] = Object.keys(
  FLIGHT_CADENCE_TO_TABLE_GRANULARITY
) as FlightCadence[];

export const SINGLE_FLIGHT_PERFORMANCE_KPIS = [
  "App Event",
  "App Install",
  "Acquisition",
  "Booking",
  "Event Response",
  "Lead Gen",
  "ROAS",
  "Purchase",
  "Local Action",
  "Submission / Entry",
  "Website Action",
] as const;
